export enum UserAccountRoles {
  ADMIN = 'ADMIN',
  CONTRIBUTOR_ALL_ORG_DATA = 'CONTRIBUTOR_ALL_ORG_DATA',
  CONTRIBUTOR_ASSIGNED_DATA = 'CONTRIBUTOR_ASSIGNED_DATA',
  VIEWER = 'VIEWER',
  USER_MANAGER = 'USER_MANAGER',
}

export const USER_ROLE_OPTIONS = [
  {
    value: UserAccountRoles.ADMIN,
    label: 'Admin',
    subtitle: 'Can configure all pages and settings',
  },
  {
    value: UserAccountRoles.CONTRIBUTOR_ALL_ORG_DATA,
    label: 'Contributor (All Org Data)',
    subtitle: 'Can view and edit all organization data',
  },
  {
    value: UserAccountRoles.CONTRIBUTOR_ASSIGNED_DATA,
    label: 'Contributor (Assigned Data)',
    subtitle: 'Can view select pages and edit assigned data',
  },
  {
    value: UserAccountRoles.VIEWER,
    label: 'Viewer',
    subtitle: 'Can view all pages',
  },
  {
    value: UserAccountRoles.USER_MANAGER,
    label: 'User Manager',
    subtitle: 'Can view all pages and manage users',
  },
]

export function useUserRoleOptions() {
  const { isUserManagerEnabled } = useFeatureFlag()
  return computed(() =>
    USER_ROLE_OPTIONS.filter(
      r => r.value !== UserAccountRoles.USER_MANAGER || isUserManagerEnabled(),
    ),
  )
}
